import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function MgtAIntroNode(props) {
    return <NodeWithMultipleHandles {...props} nodeType="mgt_a_intro" />;
}
